<template>
  <button type="button"
    class="transition-all bg-apex-blue-500 h-10 py-2 text-white rounded-lg font-bold flex justify-center"
    :class="[
      $slots.icon ? 'px-4' : 'px-6',
      loading ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
    ]">
    <div class="mr-2" v-if="$slots.icon && !loading">
      <slot name="icon" />
    </div>
    <slot />
  </button>
</template>
<script setup lang="ts">
withDefaults(defineProps<{
  loading?: boolean
}>(), {
  loading: false,
});
</script>